import React, { useContext } from 'react'
import { getImages } from '../Components/const'
import { Field, Form, Formik } from 'formik';
import ValidationError from '../Components/Errors/ValidationError';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import { VehicleContext } from '../Components/Context/VehicleContext';
import { Link, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import SeoMeta from '../Components/Common/SeoMeta';

const Contact = () => {
    const {submitContactForm} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

     const navigate = useNavigate();
    const validationSchema = Yup.object().shape({
        full_name: Yup.string()
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        phone: Yup.string()
            .required('Phone number is required'),
        comments: Yup.string()
            .max(500, 'Comments cannot exceed 500 characters'),
        //marketing_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information'),
        //marketing_info_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information')
    });
    UseScrollReveal()
    return (
        <>
            <SeoMeta
                title="Contact Us | New and Pre-Owned McLaren For Sale | McLaren Orlando"
                description="Got a question or comment? Looking to schedule a test drive, get a quote, or to order OEM parts or accessories. Contact the McLaren Orlando team today!"
                keywords=""
                ogTitle="Contact Us | New and Pre-Owned McLaren For Sale | McLaren Orlando"
                ogDescription="Got a question or comment? Looking to schedule a test drive, get a quote, or to order OEM parts or accessories. Contact the McLaren Orlando team today!"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('contact-bg.webp')} alt='contact banner' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Contact Us</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <a href='tel:4079880111' className='theme-btn text-uppercase d-inline-block'>407-988-0111</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='location-wrap d-flex align-items-center'>
                <div className='w-50'>
                    <iframe className='ci-iframe' src="https://snazzymaps.com/embed/692451" width="100%" height="494px" ></iframe>
                </div>
                <div className='w-50 contact-location-left d-flex align-items-center'>
                    <div className='w-100'>
                        <div className='mxw-660 ms-auto'>
                            <h2 className='main-title text-start mb-2 text-uppercase wow reveal fadeInUp'>Location</h2>
                            <h4 className='lb-title1 mb-1 wow reveal fadeInUp'>McLaren Orlando LLC</h4>
                            <p className='wow reveal fadeInUp'>1111 S Orlando Ave <br/>
                            Winter Park, FL 32789</p>
                            <div className='md-title text-start text-orange fw-bold mt-4 wow reveal fadeInUp'>407-988-0111</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='form-wrap'>
                <div className='container'>
                    <h3 className='xs-title font-1-2em text-orange text-uppercase fw-bold wow reveal fadeInUp'>Have a question?</h3>
                    <h2 className='lg-title text-uppercase text-white mt-1 mb-5 wow reveal fadeInUp'>How can we help?</h2>
                    <Formik
                        initialValues={{
                            full_name: '',
                            email: '',
                            phone: '',
                            comment: '',
                            marketing_agreement: false,
                            marketing_info_agreement: false
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                                // alert("Thank you for your submission. We'll be in touch soon!");
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ handleSubmit }) => (
                            <Form className="custom-form contact-form row mlr-50" autoComplete="off" name="contact-form" onSubmit={handleSubmit} >
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                />
                                <div className='col-md-6 plr-50'>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label mb-0'>Full Name</div>
                                            <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                        </div>
                                        <Field
                                            type="text"
                                            name="full_name"
                                            className="form-control"
                                            required />
                                        <ValidationError name="full_name" />
                                    </div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label mb-0'>Email</div>
                                            <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                        </div>
                                        <Field
                                            type="text"
                                            name="email"
                                            className="form-control"
                                            required />
                                        <ValidationError name="email" />
                                    </div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label mb-0'>Phone Number</div>
                                            <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                        </div>
                                        <Field
                                            type="text"
                                            name="phone"
                                            className="form-control"
                                            required />
                                        <ValidationError name="phone" />
                                        
                                    </div>
                                </div>
                                <div className='col-md-6 plr-50'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Comments</div>
                                        <Field
                                            type="text"
                                            name="comment"
                                            className="form-control h-218"
                                            component="textarea" />
                                        <ValidationError name="comment" />
                                    </div>
                                </div>
                                <div className="col-12 plr-50">
                                    <div className='form-group marketing-agree'>
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="marketing_agreement"
                                                // value="agree" 
                                                id="iAgreeChk"
                                            />
                                            <label htmlFor="iAgreeChk"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive marketing/promotional SMS messages from McLaren Orlando, including special offers, exclusive incentives, event invitations, and dealership news.</label>
                                        </div>
                                        <ValidationError name="marketing_agreement" />
                                    </div>
                                    <div className="form-group marketing-agree">
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="marketing_info_agreement"
                                                // value="agree" 
                                                id="iAgreeChk2"
                                            />
                                            <label htmlFor="iAgreeChk2"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive informational/transactional SMS messages from McLaren Orlando, such as appointment reminders, service updates, vehicle status notifications, and important account-related information.</label>
                                        </div>
                                        <ValidationError name="marketing_info_agreement" />
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-checkbox fin_app_chkbox mb-4">
                                            <div  className="cs-label fw-400 font-12 pt-1 custom-breadcrumb">By providing your mobile number and checking the above box/es, you agree to related text messages from McLaren Orlando at the phone number you provided when signing up. Reply STOP to unsubscribe, Reply HELP for help. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. For more information, please review our Privacy Policy <Link to="https://cars.mclaren.com/us_en/privacy-policy">Privacy Policy</Link> and <Link to="https://cars.mclaren.com/us_en/terms-conditions">Terms of Service</Link></div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 text-end plr-50'>
                                    <button type='submit' className='theme-btn text-uppercase mnw-300 d-inline-block'>Send</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </section>
        </>
    )
}

export default Contact